define('app-UpdatePassengerTP/main',['./settings'], function (settings) {
    return {
        run: function () {
            if ($(settings.container).length === 0) {
                window.log("No Portal Container found, update passenger details will not be available.");

                return;
            }

            $(settings.passengerFullNamePlaceholder).html($(settings.customerFullName).val());

            function toggleInputDisplay(what, displayInput) {
                var displayDiv = false;
                var inputDiv = false;

                switch (what) {
                    case "passenger":
                        displayDiv = $(settings.passengerDetails);
                        inputDiv = $(settings.passengerDetailsUpdate);

                        break;
                    case "nextofkin":
                        displayDiv = $(settings.emergencyContactDetails);
                        inputDiv = $(settings.emergencyContactDetailsUpdate);

                        break;
                    case "passport":
                        displayDiv = $(settings.passportDetails);
                        inputDiv = $(settings.passportDetailsUpdate);

                        break;
                }

                if (!displayDiv || !inputDiv) return;

                if (displayInput === true || displayInput === false) {
                    if (displayInput == true) {
                        displayDiv.hide();
                        inputDiv.show();
                    } else {
                        displayDiv.show();
                        inputDiv.hide();
                    }
                } else {
                    if (displayDiv.is(':hidden')) {
                        displayDiv.show();
                        inputDiv.hide();
                    } else {
                        displayDiv.hide();
                        inputDiv.show();
                    }
                }
            }

            function updateErrorMessage(error, additional) {
                if (error !== "") {
                    error += "<br />";
                }

                error += additional;

                return error;
            }

            function displayNotification(container, message) {
                $(container).find(".notification").html(message).removeClass("d-none");
            }

            function hideNotification(container) {
                $(container).find(".notification").addClass("d-none");
            }

            $(settings.editPassengerDetails).on("click", function (event) {
                event.preventDefault();
                $(settings.editEmergencyContactDetails).hide();
                $(settings.editPassportDetails).hide();

                $(this).closest("fieldset").find(".alert").remove();

                toggleInputDisplay("passenger", true);
                toggleInputDisplay("passport", false);
                toggleInputDisplay("nextofkin", false);

                var mobileNumber = $(settings.mobileNumberField),
                    hasMobileNumber = $(settings.hasMobileNumber);

                //If the mobile number textbox has an input value then disable the no mobile button and uncheck it.
                if (mobileNumber.val() != "") {
                    hasMobileNumber.prop('disabled', true).prop('checked', false);
                    //Else if then enable the no mobile checkbox.
                } else {
                    hasMobileNumber.prop('disabled', false);
                }

                //If the user inputs a mobile number then disable the no mobile tickbox, and uncheck it if it's ticked.
                //Checks on change of the input.
                $(mobileNumber).on('input', function () {
                    $(this).val() != "" ? hasMobileNumber.prop('disabled', true).prop('checked', false) : hasMobileNumber.prop('disabled', false);
                });

                mobileNumber.prop('disabled', hasMobileNumber.is(':checked'));

                hasMobileNumber.on('change', function () {
                    mobileNumber.prop('disabled', $(this).is(':checked'));
                });
            });

            $(settings.cancelEditPassengerDetails).on("click", function (event) {
                event.preventDefault();

                toggleInputDisplay("passenger", false);
                $(settings.editEmergencyContactDetails).show();
                $(settings.editPassportDetails).show();
            });

            $(settings.editEmergencyContactDetails).on("click", function (event) {
                event.preventDefault();

                $(settings.editPassengerDetails).hide();
                $(settings.editPassportDetails).hide();

                $(this).closest("fieldset").find(".alert").remove();

                toggleInputDisplay("passenger", false);
                toggleInputDisplay("passport", false);
                toggleInputDisplay("nextofkin", true);
            });

            $(settings.cancelEditEmergencyContactDetails).on("click", function (event) {
                event.preventDefault();

                toggleInputDisplay("nextofkin", false);

                $(settings.editPassengerDetails).show();
                $(settings.editPassportDetails).show();
            });

            $(settings.editPassportDetails).on("click", function (event) {
                event.preventDefault();
                $(settings.editEmergencyContactDetails).hide();
                $(settings.editPassengerDetails).hide();

                $(this).closest("fieldset").find(".alert").remove();

                toggleInputDisplay("passenger", false);
                toggleInputDisplay("passport", true);
                toggleInputDisplay("nextofkin", false);
            });

            $(settings.cancelEditPassportDetails).on("click", function (event) {
                event.preventDefault();

                $(settings.editEmergencyContactDetails).show();
                $(settings.editPassengerDetails).show();

                toggleInputDisplay("passport", false);
            });

            $(settings.submitPassengerDetails).on("click", function () {
                var container = $(settings.passengerDetailsUpdate);
                var errorMessage = "";
                var isPaperless = $("#emailDocumentPreference").prop("checked");
                var email = $("#txtEmail").val();
                var pattern = /[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,8}/g;

                if (isPaperless) {
                    if (!email) {
                        errorMessage = "Email address is required.";
                    } else if (!email.match(pattern)) {
                        errorMessage = "Invalid email address entered.";
                    }
                }

                displayNotification(container, errorMessage);

                if (errorMessage !== "") {
                    return false;
                }
            });

            $(settings.submitEmergencyContactDetails).on("click", function (event) {
                var container = $(settings.emergencyContactDetailsUpdate);
                var errorMessage = "";
                var isValid = true;

                var firstname = container.find('.EmgFirstName')
                    .val()
                    .replace(/\s{2}/g, " ");

                var lastname = container.find('.EmgLastName')
                    .val()
                    .replace(/\s{2}/g, " ");

                var relationship = container.find('.EmgRelationship')
                    .val()
                    .replace(/\s{2}/g, " ");

                var telephone = container.find('.EmgTelephone')
                    .val()
                    .replace(/\s{2}/g, " ");

                //replace additional spaces with a single space
                // check to see if empty
                if (!firstname) {
                    errorMessage = updateErrorMessage(errorMessage, "Forename must be entered");
                }

                if (!lastname) {
                    errorMessage = updateErrorMessage(errorMessage, "Last Name must be entered.");
                }

                if (!relationship) {
                    errorMessage = updateErrorMessage(errorMessage, "Relationship must be entered.");
                }

                if (!telephone) {
                    errorMessage = updateErrorMessage(errorMessage, "Telephone must be entered.");
                }

                var pattern = /[^a-zA-Z0-9_-]+( [^a-zA-Z0-9_-])/g;
                var numeric = /[^0-9-_]+( [^0-9_-])/g;

                if (firstname.match(pattern)) {
                    errorMessage = updateErrorMessage(errorMessage, "Invalid forename.");
                }

                if (lastname.match(pattern)) {
                    errorMessage = updateErrorMessage(errorMessage, "Invalid surname.");
                }

                if (relationship.match(pattern)) {
                    errorMessage = updateErrorMessage(errorMessage, "Invalid relationship.");
                }

                if (telephone.match(numeric)) {
                    errorMessage = updateErrorMessage(errorMessage, "Invalid telephone.");
                }

                displayNotification(container, errorMessage);

                if (errorMessage != "") {
                    isValid = false;
                }

                return isValid;
            });

            $(settings.submitPassportDetails).on("click", function () {
                var container = $(settings.passportDetailsUpdate);
                var errorMessage = "";
                hideNotification(container);

                var isValid = true;
                var issueCountry = $('#PassportDetailsModel_SelectedCountry').val();
                var passportNumber = container.find('.inputPassportNo').val();

                var issueDateDay = container.find('#issueDateDay').val();
                var issueDateMonth = container.find('#issueDateMonth').val();
                var issueDateYear = container.find('#issueDateYear').val();
                var issueDate = issueDateDay + "/" + issueDateMonth + "/" + issueDateYear;

                if (!issueDateDay || !issueDateMonth || !issueDateYear) {
                    errorMessage = updateErrorMessage(errorMessage, "Issue date must be entered.");
                }

                container.find("#issueDate").val(issueDate);

                var expiryDateDay = container.find('#expiryDateDay').val();
                var expiryDateMonth = container.find('#expiryDateMonth').val();
                var expiryDateYear = container.find('#expiryDateYear').val();
                var expiryDate = expiryDateDay + "/" + expiryDateMonth + "/" + expiryDateYear;

                if (!expiryDateDay || !expiryDateMonth || !expiryDateYear) {
                    errorMessage = updateErrorMessage(errorMessage, "Expiry date must be entered.");
                }

                container.find("#expiryDate").val(expiryDate);

                if (!passportNumber) {
                    errorMessage = updateErrorMessage(errorMessage, "Passport number must be entered.");
                }

                var passportNumberPattern = new RegExp();
                //If the issue country is UK, passport number must only contain digits.
                if (issueCountry === "GB") {
                    passportNumberPattern = new RegExp(/^[0-9]*$/g);
                    if (!passportNumberPattern.test(passportNumber)) {
                        errorMessage = updateErrorMessage(errorMessage, "Passport number must only contain digits 0-9.");
                    }
                } else {
                    passportNumberPattern = new RegExp(/^[A-Za-z0-9]*$/g);
                    if (!passportNumberPattern.test(passportNumber)) {
                        errorMessage = updateErrorMessage(errorMessage, "Invalid Passsport number.");
                    }
                }

                var pattern = /[<>?]/g;

                if (issueDate.match(pattern)) {
                    errorMessage = updateErrorMessage(errorMessage, "Invalid Issue date.");
                }

                if (expiryDate.match(pattern)) {
                    errorMessage = updateErrorMessage(errorMessage, "Invalid Expiry date.");
                }                

                if (errorMessage != "") {
                    displayNotification(container, errorMessage);
                    isValid = false;
                }

                return isValid;
            });
        }
    }
});
